import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import PrivateRoute from "./PrivateRouting";
import ProtectedLoginRoute from "./ProtectedLoginRoute";
import { RoutesLink } from "@/utility/RouteLinks";
import Login from "@/pages/auth/Login";
import SuperAdminDashboard from "@/pages/SuperAdmin/Dashboard/SuperAdminDashboard";
import Forgot from "@/pages/auth/Forgot";
import VerifyOtp from "@/pages/auth/VerifyOtp";
import ResetPassword from "@/pages/auth/ResetPassword";
import Employees from "@/pages/SuperAdmin/Employee/Employees";
import CreateEmployee from "@/pages/SuperAdmin/Employee/CreateEmployee";
import BulkImportEmployee from "@/pages/SuperAdmin/Employee/BulkImport/BulkImportEmployee";
import Department from "@/pages/SuperAdmin/Department/Department";
import AddDepartment from "@/pages/SuperAdmin/Department/AddDepartment";
import Branch from "@/pages/SuperAdmin/Branch/Branch";
import AddBranch from "@/pages/SuperAdmin/Branch/AddBranch";
import Company from "@/pages/SuperAdmin/Company/Company";
import CreateCompany from "@/pages/SuperAdmin/Company/CreateCompany";
import ShiftAndTime from "@/pages/SuperAdmin/ShiftAndTime/ShifAndTime";
import AddShiftAndTime from "@/pages/SuperAdmin/ShiftAndTime/AddShiftAndTime";
import ShiftAndTimeDetail from "@/pages/SuperAdmin/ShiftAndTime/ShiftAndTimeDetail";
import Designation from "@/pages/SuperAdmin/Designation/Designation";
import AddDesignation from "@/pages/SuperAdmin/Designation/AddDesignation";
import SsoLogin from "@/pages/auth/SsoLogin";
import Site from "@/pages/SuperAdmin/Site/Site";
import AddSite from "@/pages/SuperAdmin/Site/AddSite";
import AddCampus from "@/pages/SuperAdmin/Campus/AddCampus";
import CampusConfig from "@/pages/SuperAdmin/Campus/CampusConfig";
import Application from "@/pages/SuperAdmin/Applications/Application";
import AddApplication from "@/pages/SuperAdmin/Applications/AddApplication";
import Profile from "@/pages/SuperAdmin/Profile/Profile";
import EmployeeDetail from "@/pages/SuperAdmin/Employee/EmployeeDetail";
import LeaveSetting from "@/pages/SuperAdmin/HrmsSettings/LeaveSettings/LeaveSettings";
import AddLeaveSetting from "@/pages/SuperAdmin/HrmsSettings/LeaveSettings/AddLeaveSetting";
import AddLeave from "@/pages/SuperAdmin/Leave/AddLeave";
import LeaveDetail from "@/pages/SuperAdmin/Leave/LeaveDetail";
import TeamLeave from "@/pages/SuperAdmin/Leave/TeamLeave";
import MyLeave from "@/pages/SuperAdmin/Leave/MyLeave";
import UserDashboard from "@/pages/Dashboard/UserDashboard";
import MyAttendance from "@/pages/SuperAdmin/Attendance/MyAttendance";
import WFHRequest from "@/pages/SuperAdmin/WFH/WFHRequest";
import WFHTeam from "@/pages/SuperAdmin/WFH/WFHTeam";
import ADDWFH from "@/pages/SuperAdmin/WFH/ADDWFH";
import WfhDetail from "@/pages/SuperAdmin/WFH/WfhDetail";
import MyOd from "@/pages/SuperAdmin/Od/MyOd";
import TeamOd from "@/pages/SuperAdmin/Od/TeamOd";
import Payslip from "@/pages/SuperAdmin/Payslip/Payslip";
import OdDetail from "@/pages/SuperAdmin/Od/OdDetail";
import CreateOd from "@/pages/SuperAdmin/Od/CreateOd";
import AttendanceLog from "@/pages/SuperAdmin/Attendance/AttendaceLog";
import Organisation from "@/pages/SuperAdmin/Organisation/Organisation";

// import { useEffect } from 'react';
import { useSelector } from "react-redux";

import type { RootState } from "@/store/store";
import { permissionKeys } from "@/utility/helper";
import DailyTeamAttendance from "@/pages/SuperAdmin/Attendance/DailyTeamAttendance";
import MyRegularization from "@/pages/SuperAdmin/Regularization/MyRegularization";
import TeamRegularization from "@/pages/SuperAdmin/Regularization/TeamRegularization";
import CreateRegularization from "@/pages/SuperAdmin/Regularization/CreateRegularization";
import RegularizationDetails from "@/pages/SuperAdmin/Regularization/RegularizationDetails";
import MonthlyTeamAttendance from "@/pages/SuperAdmin/Attendance/MonthlyTeamAttendance";
import MonthlySalaryPreview from "@/pages/SuperAdmin/Attendance/MonthlySalaryPreview/index";


import SalaryHead from "@/pages/SuperAdmin/SalaryHead/SalaryHead";
import AddSalaryHead from "@/pages/SuperAdmin/SalaryHead/AddSalaryHead";
import OfficeSalaryHead from "@/pages/SuperAdmin/OfficeSalaryHead/BrachSalaryHead";
import AddOfficeSalaryHead from "@/pages/SuperAdmin/OfficeSalaryHead/AddBrachSalaryHead";
import Holiday from "@/pages/SuperAdmin/HrmsSettings/HolidaySettings/Holiday";
import AddHoliday from "@/pages/SuperAdmin/HrmsSettings/HolidaySettings/AddHoliday";
import Notification from "@/pages/SuperAdmin/Notification/Notification";
import Onboard from "@/pages/SuperAdmin/OnBoard/OnBoard";
import ViewSalaryHead from "@/pages/SuperAdmin/SalaryHead/ViewSalaryHead";
import CreateCompanyDocument from "@/pages/SuperAdmin/CompanyDocument/CreateConpanyDocument";
import CompanyDocument from "@/pages/SuperAdmin/CompanyDocument/CompanyDocument";
import ViewCompanyDocument from "@/pages/SuperAdmin/CompanyDocument/ViewCompanyDocument";
import Setting from "@/pages/SuperAdmin/Setting/Setting";
import OffboardingList from "@/pages/SuperAdmin/Offboarding/OffboardingList";
import StartOffboarding from "@/pages/SuperAdmin/Offboarding/StartOffboarding";
import ExitClearanceList from "@/pages/SuperAdmin/Offboarding/ExitClearance/ExitClearanceList";
import ExitClearanceDetail from "@/pages/SuperAdmin/Offboarding/ExitClearance/ExitClearanceDetail";
import TeamsPayslip from "@/pages/SuperAdmin/Payslip/TeamsPayslip";
import BranchSalaryConfig from "@/pages/SuperAdmin/HrmsSettings/BranchSalaryBackupsConfig/BranchSalaryConfig";
import CreateSalary from "@/pages/SuperAdmin/CreateSalary/CreateSalary";
import BranchUsersPayslip from "@/pages/SuperAdmin/Payslip/BranchUsersPayslip";
import ManageMonthlyBulkAttendance from "@/pages/SuperAdmin/Attendance/ManageMonthlyBulkAttendance";
import Transfer from "@/pages/SuperAdmin/HrmsSettings/Transfer/Transfer";

// import ViewSalaryHead from '@/pages/SuperAdmin/SalaryHead/viewSalaryHead';

interface IPrivateRoutes {
    path: string;
    route: React.ReactNode;
    accessKey?: string;
    teamAccess?: boolean;
}

interface IAccessGuard {
    element: React.ReactNode;
    accessKey?: string;
    teamAccess?: boolean;
}

const AccessGuard: React.FC<IAccessGuard> = ({
    element,
    accessKey,
    teamAccess,
}) => {
    const { user: userDetails, userDetailsLoading } = useSelector(
        (state: RootState) => state.user,
    );

    // Wait until user details are loaded to prevent race conditions / incorrect redirection
    if (
        !userDetails &&
        (userDetailsLoading === "pending" || userDetailsLoading === "idle")
    ) {
        return null;
    }

    // Admins bypass designation access restrictions
    const isAdmin =
        userDetails?.type === "admin" || userDetails?.type === "super_admin";

    // Level 0 or 1 gets all access (bypass designation access restrictions)
    const level = userDetails?.designation?.level;
    const isLevelAdmin =
        level !== undefined &&
        level !== null &&
        (Number(level) === 0 || Number(level) === 1);

    if (isAdmin || isLevelAdmin) {
        return <>{element}</>;
    }

    // Check specific access keys (e.g. attendance, leave, wfh)
    if (accessKey) {
        let hasAccess = false;

        // 1. Try level-based access check first (if level matches accessKey directly)
        if (level !== undefined && level !== null) {
            if (Array.isArray(level)) {
                hasAccess = level.some((l: any) => String(l) === String(accessKey));
            } else {
                hasAccess = String(level) === String(accessKey);
            }
        }

        // 2. Fallback to check from menuBar if level check did not grant access
        if (!hasAccess) {
            const menuBar = userDetails?.designation?.menuBar?.keyNames;
            hasAccess = Array.isArray(menuBar) && menuBar.includes(accessKey);
        }

        if (!hasAccess) {
            return <Navigate to={RoutesLink.dashboard} replace />;
        }
    }

    // Check team access restrictions
    if (teamAccess && !userDetails?.designation?.canAccessTeam) {
        return <Navigate to={RoutesLink.dashboard} replace />;
    }

    return <>{element}</>;
};

export default function CommonRouts() {
    // const dispatch = useDispatch<AppDispatch>();

    // useEffect(() => {
    //     const token = Boolean(getCookies(`${import.meta.env.VITE_BUSINESS}token`));
    //     if (token) {
    //         dispatch(fetchUserDetails());
    //     }
    // }, [dispatch]);

    const ProtectedLoginRoutes = [
        {
            path: RoutesLink?.authRoutes?.login,
            route: <Login />,
        },
        {
            path: RoutesLink?.authRoutes?.forgot,
            route: <Forgot />,
        },
        {
            path: RoutesLink?.authRoutes?.verifyOtp,
            route: <VerifyOtp />,
        },
        {
            path: RoutesLink?.authRoutes?.resetPassword,
            route: <ResetPassword />,
        },
    ];

    const privateRoutes: IPrivateRoutes[] = [
        {
            path: RoutesLink.superAdminDashboard,
            route: <SuperAdminDashboard />,
        },
        {
            path: RoutesLink.userDashboard,
            route: <UserDashboard />,
        },
        {
            path: RoutesLink.notification,
            route: <Notification />,
        },
        {
            path: RoutesLink?.holidayList,
            route: <Holiday isAdmin={false} />,
        },
        {
            path: RoutesLink?.superAdminOnboard,
            route: <Onboard />,
            accessKey: permissionKeys.onboard,
        },
        // employee
        // {
        //     path: RoutesLink.superAdminEmployees,
        //     route: <Employees />,
        // },
        {
            path: RoutesLink.superAdminEmplyoeeOnboard,
            route: <Employees />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.employeeDetail}/:id`,
            route: <EmployeeDetail />,
            // accessKey: permissionKeys.hrmSetting,
        },
        {
            path: RoutesLink.createEmployee,
            route: <CreateEmployee />,
        },
        {
            path: `${RoutesLink.editEmployee}/:id`,
            route: <CreateEmployee />,
        },
        {
            path: RoutesLink.bulkImportEmployee,
            route: <BulkImportEmployee />,
            accessKey: permissionKeys.hrmSetting,
        },
        // Offboarding
        {
            path: RoutesLink.offboardingList,
            route: <OffboardingList />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: RoutesLink.startOffboarding,
            route: <StartOffboarding />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.startOffboarding}/:id`,
            route: <StartOffboarding />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.startOffboarding}/:id/:offboardingId`,
            route: <StartOffboarding />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.editOffboarding}/:id`,
            route: <StartOffboarding />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.editOffboarding}/:id/:offboardingId`,
            route: <StartOffboarding />,
            accessKey: permissionKeys.hrmSetting,
        },
        // Exit Clearance
        {
            path: RoutesLink.exitClearanceList,
            route: <ExitClearanceList />,
            accessKey: permissionKeys.exitClearance,
        },
        {
            path: `${RoutesLink.viewExitClearance}/:id`,
            route: <ExitClearanceDetail />,
            accessKey: permissionKeys.exitClearance,
        },
        // Profile
        {
            path: RoutesLink.profile,
            route: <Profile />,
        },

        {
            path: RoutesLink.superAdminDepartment,
            route: <Department />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: RoutesLink.addDepartment,
            route: <AddDepartment />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.editDepartment}/:id`,
            route: <AddDepartment />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: RoutesLink.superAdminBranch,
            route: <Branch />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: RoutesLink.addBranch,
            route: <AddBranch />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.editBranch}/:id`,
            route: <AddBranch />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: RoutesLink.company,
            route: <Company />,
            accessKey: permissionKeys.company,
        },
        {
            path: RoutesLink.createCompany,
            route: <CreateCompany />,
            accessKey: permissionKeys.company,
        },
        {
            path: `${RoutesLink.editCompany}/:id`,
            route: <CreateCompany />,
            accessKey: permissionKeys.company,
        },
        {
            path: RoutesLink.shiftAndTime,
            route: <ShiftAndTime />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: RoutesLink.addShiftAndTime,
            route: <AddShiftAndTime />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.editShiftAndTime}/:id`,
            route: <AddShiftAndTime />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.viewShiftAndTime}/:id`,
            route: <ShiftAndTimeDetail />,
            accessKey: permissionKeys.hrmSetting,
        },
        //   designation
        {
            path: RoutesLink.superAdminDesignation,
            route: <Designation />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: RoutesLink.addDesignation,
            route: <AddDesignation />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.editDesignation}/:id`,
            route: <AddDesignation />,
            accessKey: permissionKeys.hrmSetting,
        },
        // Site
        {
            path: RoutesLink.superAdminSite,
            route: <Site />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: RoutesLink.addSite,
            route: <AddSite />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.editSite}/:id`,
            route: <AddSite />,
            accessKey: permissionKeys.hrmSetting,
        },
        // campus
        {
            path: RoutesLink.superAdminCampus,
            route: <CampusConfig />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: RoutesLink.addCampus,
            route: <AddCampus />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.editCampus}/:id`,
            route: <AddCampus />,
            accessKey: permissionKeys.hrmSetting,
        },
        // applications
        {
            path: RoutesLink.superAdminApplication,
            route: <Application />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: RoutesLink.addApplication,
            route: <AddApplication />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.editApplication}/:id`,
            route: <AddApplication />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: RoutesLink.profile,
            route: <Profile />,
        },
        // {
        //     path: RoutesLink.editProfile,
        //     route: <EditProfile />,
        // },
        // Leave Setting
        {
            path: RoutesLink.leaveSetting,
            route: <LeaveSetting />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: RoutesLink.addLeaveSetting,
            route: <AddLeaveSetting />,
            accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.editLeaveSetting}/:id`,
            route: <AddLeaveSetting />,
            accessKey: permissionKeys.hrmSetting,
        },
        // Leave
        {
            path: RoutesLink.addLeave,
            route: <AddLeave />,
            accessKey: permissionKeys.leave,
        },
        {
            path: `${RoutesLink.editLeave}/:id`,
            route: <AddLeave />,
            accessKey: permissionKeys.leave,
        },
        {
            path: `${RoutesLink.leaveDetail}/:id`,
            route: <LeaveDetail />,
            accessKey: permissionKeys.leave,
        },
        {
            path: `${RoutesLink.teamLeaveDetail}/:id`,
            route: <LeaveDetail />,
            accessKey: permissionKeys.leave,
            teamAccess: true,
        },
        {
            path: RoutesLink.teamLeave,
            route: <TeamLeave />,
            accessKey: permissionKeys.leave,
            teamAccess: true,
        },
        {
            path: RoutesLink.myLeave,
            route: <MyLeave />,
            accessKey: permissionKeys.leave,
        },
        // attendance
        {
            path: RoutesLink.myAttendance,
            route: <MyAttendance />,
            accessKey: permissionKeys.attendance,
        },
        {
            path: `${RoutesLink.monthlyTeamAttendanceSummary}/:id`,
            route: <MyAttendance />,
            accessKey: permissionKeys.attendance,
        },
        {
            path: RoutesLink.attendanceLog,
            route: <AttendanceLog />,
            accessKey: permissionKeys.attendance,
        },
        {
            path: RoutesLink?.dailyTeamAttendance,
            route: <DailyTeamAttendance />,
            // teamAccess: true,
            accessKey: permissionKeys.attendance,
        },
        {
            path: RoutesLink?.monthlyTeamAttendance,
            route: <MonthlyTeamAttendance />,
            // teamAccess: true,
            accessKey: permissionKeys.attendance,
        },
        {
            path: RoutesLink?.monthlySalaryPreview,
            route: <MonthlySalaryPreview />,
            accessKey: permissionKeys.attendance,
        },
        {
            path: RoutesLink?.manageMonthlyBulkAttendance,
            route: <ManageMonthlyBulkAttendance />,
            accessKey: permissionKeys.attendance,
        },

        // transfer
        {
            path: RoutesLink.transfer,
            route: <Transfer />,
            // accessKey: permissionKeys.transfer,
        },


        // WFH
        {
            path: RoutesLink.wfhRequest,
            route: <WFHRequest />,
            accessKey: permissionKeys.wfh,
        },
        {
            path: RoutesLink.teamWfh,
            route: <WFHTeam />,
            accessKey: permissionKeys.wfh,
            teamAccess: true,
        },
        {
            path: RoutesLink.addWfh,
            route: <ADDWFH />,
            accessKey: permissionKeys.wfh,
        },
        {
            path: `${RoutesLink.editWfh}/:id`,
            route: <ADDWFH />,
            accessKey: permissionKeys.wfh,
        },
        {
            path: `${RoutesLink.wfhDetail}/:id`,
            route: <WfhDetail />,
            accessKey: permissionKeys.wfh,
        },
        {
            path: `${RoutesLink.teamWfhDetail}/:id`,
            route: <WfhDetail />,
            accessKey: permissionKeys.wfh,
            teamAccess: true,
        },
        // OD
        {
            path: RoutesLink.myOd,
            route: <MyOd />,
            accessKey: permissionKeys.od,
        },
        {
            path: RoutesLink.teamOd,
            route: <TeamOd />,
            accessKey: permissionKeys.od,
            teamAccess: true,
        },
        {
            path: RoutesLink.createOd,
            route: <CreateOd />,
            accessKey: permissionKeys.od,
        },
        {
            path: `${RoutesLink.editOd}/:id`,
            route: <CreateOd />,
            accessKey: permissionKeys.od,
        },
        {
            path: `${RoutesLink.teamOdDetail}/:id`,
            route: <OdDetail />,
            accessKey: permissionKeys.od,
            teamAccess: true,
        },
        {
            path: `${RoutesLink.odDetail}/:id`,
            route: <OdDetail />,
            accessKey: permissionKeys.od,
            teamAccess: true,
        },
        // Regularization
        {
            path: RoutesLink.myRegularization,
            route: <MyRegularization />,
            accessKey: permissionKeys.regularization,
        },
        {
            path: RoutesLink.teamRegularization,
            route: <TeamRegularization />,
            accessKey: permissionKeys.regularization,
            teamAccess: true,
        },
        {
            path: RoutesLink.createRegularization,
            route: <CreateRegularization />,
            accessKey: permissionKeys.regularization,
        },
        {
            path: `${RoutesLink.editRegularization}/:id`,
            route: <CreateRegularization />,
            accessKey: permissionKeys.regularization,
        },
        {
            path: `${RoutesLink.regularizationDetail}/:id`,
            route: <RegularizationDetails />,
            accessKey: permissionKeys.regularization,
        },
        {
            path: `${RoutesLink.teamsRegularizationDetail}/:id`,
            route: <RegularizationDetails />,
            accessKey: permissionKeys.regularization,
            teamAccess: true,
        },
        // Payslip
        {
            path: RoutesLink.payslip,
            route: <Payslip />,
            accessKey: permissionKeys.payslip,

        },
        {
            path: RoutesLink.teamsPayslip,
            route: <TeamsPayslip />,
            accessKey: permissionKeys.payslip,
            teamAccess: true,

        },

        {
            path: `${RoutesLink.branchUserPayslip}/:id`,
            route: <BranchUsersPayslip />,
            accessKey: permissionKeys.payslip,
            teamAccess: true,

        },
        // organisation
        {
            path: RoutesLink.superAdminOrganisation,
            route: <Organisation />,
            // teamAccess: true,
            accessKey: permissionKeys.organisation,
        },

        // salary head
        {
            path: RoutesLink.salaryHead,
            route: <SalaryHead />,
            // accessKey: permissionKeys.salaryHead,
        },
        {
            path: RoutesLink.addSalaryHead,
            route: <AddSalaryHead />,
            // accessKey: permissionKeys.salaryHead,
        },
        {
            path: `${RoutesLink.editSalaryHead}/:id`,
            route: <AddSalaryHead />,
            // accessKey: permissionKeys.salaryHead,
        },
        {
            path: `${RoutesLink.SalaryHeadDetails}/:id`,
            route: <ViewSalaryHead />,
            // accessKey: permissionKeys.salaryHead,
        },

        // office salary head
        {
            path: RoutesLink.branchSalaryHead,
            route: <OfficeSalaryHead />,
            // accessKey: permissionKeys.salaryHead,
        },
        {
            path: RoutesLink.addBranchSalaryHead,
            route: <AddOfficeSalaryHead />,
            // accessKey: permissionKeys.salaryHead,
        },
        {
            path: `${RoutesLink.editBranchSalaryHead}/:id`,
            route: <AddOfficeSalaryHead />,
            // accessKey: permissionKeys.salaryHead,
        },

        // create salary
        {
            path: RoutesLink.createSalary,
            route: <CreateSalary />,
            // accessKey: permissionKeys.salaryHead,
        },



        // company document

        // office salary head
        {
            path: RoutesLink.createCompanyDocument,
            route: <CreateCompanyDocument />,
            // accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.editCompanyDocument}/:id`,
            route: <CreateCompanyDocument />,
            // accessKey: permissionKeys.hrmSetting,
        },
        {
            path: `${RoutesLink.companyDocumentDetail}/:id`,
            route: <ViewCompanyDocument />,
            // accessKey: permissionKeys.hrmSetting,
        },
        {
            path: RoutesLink.companyDocument,
            route: <CompanyDocument />,
            // accessKey: permissionKeys.hrmSetting,
        },

        // holiday
        {
            path: RoutesLink.superAdminHoliday,
            route: <Holiday isAdmin={true} />,
            // accessKey: permissionKeys.holiday,
        },
        {
            path: RoutesLink.addHoliday,
            route: <AddHoliday />,
            // accessKey: permissionKeys.holiday,
        },
        {
            path: `${RoutesLink.editHoliday}/:id`,
            route: <AddHoliday />,
            // accessKey: permissionKeys.holiday,
        },
        // setting
        {
            path: RoutesLink.documentSetting,
            route: <Setting />,
            // accessKey: permissionKeys.setting,
        },
        // Branch Salary Backup
        {
            path: RoutesLink.branchSalaryBackup,
            route: <BranchSalaryConfig />,
            accessKey: permissionKeys.hrmSetting,
        },

    ];

    const location = useLocation();

    return (
        <>
            <Routes>
                {ProtectedLoginRoutes.map((route, index) => (
                    <Route
                        key={`login-${index}`}
                        path={route.path}
                        element={<ProtectedLoginRoute element={route.route} />}
                    />
                ))}

                {/* All Private Routes — generated per role */}
                {privateRoutes.map((route, index) => (
                    <Route
                        key={`private-${index}`}
                        path={route.path}
                        element={
                            <PrivateRoute
                                element={
                                    <AccessGuard
                                        element={route.route}
                                        accessKey={route.accessKey}
                                        teamAccess={route.teamAccess}
                                    />
                                }
                            />
                        }
                    />
                ))}

                {/* Public standalone route — accessible regardless of auth state */}
                <Route path={RoutesLink.authRoutes.ssoLogin} element={<SsoLogin />} />

                {/* Global Fallback */}
                <Route
                    path="*"
                    element={
                        <Navigate
                            to={{
                                pathname: RoutesLink.authRoutes.login,
                                search: location.search,
                            }}
                            replace
                        />
                    }
                />
            </Routes>
        </>
    );
}
